export default "__VITE_ASSET__DGLztcKE__"